import PubSub from "underpub-js";

var FooterLeft = function(options) {

	this.options = {
		$el: false,
		baseClass: 'mol-FooterLeft',
	};

	$.extend(true, this.options, options);

};

FooterLeft.prototype.init = function() {

	var self = this;

};

export default FooterLeft;
